import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CustomerBuilderGeneralTab from "./tabs/CustomerBuilderGeneralTab";
import CustomerBuilderCardsTab from "./tabs/CustomerBuilderCardsTab";
import CustomerBuilderNotesTab from "./tabs/CustomerBuilderNotesTab";
import CustomerBuilderPaymentsTab from "./tabs/CustomerBuilderPaymentsTab";
import CustomerBuilderReservationsTab from "./tabs/CustomerBuilderReservationsTab";
import CustomerBuilderEmailsTab from "./tabs/CustomerBuilderEmailsTab";
import CustomerBuilderVouchersTab from "./tabs/CustomerBuilderVouchersTab";
import MessageLog from "../MessageLog/MessageLog";
import Tabs from '../Tabs/Tabs';

class CustomerBuilder extends React.Component {
  constructor(props) {
    super(props);
    var self = this;

    this.state = {
      active_tab: this.props.active_tab,
      customer: this.props.customer.customer ? this.props.customer.customer : null,
      answers: this.props.answers ? this.props.answers : null,
      forms: this.props.forms ? this.props.forms : [],
      form_titles: this.props.form_titles ? this.props.form_titles : [],
      loading: false,
      removedCards: [],
      note_count: this.props.note_count || null,
      note_obj: this.props.note || {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null,
      },
      file_group: this.props.file_group,
      rating_answers: this.props.rating_answers ? this.props.rating_answers : [],
      emoji_answers: this.props.emoji_answers ? this.props.emoji_answers : [],
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeCardForm = this.onChangeCardForm.bind(this);
    this.onChangeNote = this.onChangeNote.bind(this);
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this);
    this.onChangeFlagged = this.onChangeFlagged.bind(this);
    this.updateNoteCount = this.updateNoteCount.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.onChangeFormFields = this.onChangeFormFields.bind(this);
    this.autocomplete = null;
    this.onChangeSelectedRating = this.onChangeSelectedRating.bind(this)
    this.onChangeSelectedEmoji = this.onChangeSelectedEmoji.bind(this)
    this.onChangeFormFieldFileUploadGroup = this.onChangeFormFieldFileUploadGroup.bind(this)
    this.onChangeAddress = this.onChangeAddress.bind(this)
    // this.handlePlaceSelect = this.handlePlaceSelect.bind(this)
  };

  async componentDidMount(){
    this.autocomplete = await new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ['address'] })
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
  };

  componentDidUpdate() {
    // if(this.autocomplete) {
      this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ['address'] })
      this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
    // }
  }
  
  render() {
    // console.log("customer buld state", this.state)
    var self = this;
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.save();
          return false;
        },
      },
    ];
    if(this.props.new_record === true) {
      return (
        <div className="CustomerBuilder">
          <div className="panel panel-form">
            <Tabs tabs={this.tabs()} />
            <div className="tab-content">
              <CustomerBuilderGeneralTab {...this.props} {...this.state} onChange={this.onChange}  onChangeFormFields={this.onChangeFormFields} onChangeSelectedRating={this.onChangeSelectedRating} onChangeSelectedEmoji={this.onChangeSelectedEmoji} onChangeAddress={this.onChangeAddress} handlePlaceSelect={this.handlePlaceSelect}/>
              {/* <CustomerBuilderCardsTab {...this.props} {...this.state} onChangeCardForm={this.onChangeCardForm} /> */}
              <CustomerBuilderNotesTab {...this.props} {...this.state} buttons={buttons} updateNoteCount={this.updateNoteCount} onChangeFileUploadGroup={this.onChangeFileUploadGroup} onChangeNote={this.onChangeNote} onChangeFlagged={this.onChangeFlagged}  />
            </div>
            <ModalButtons loading={this.state.loading} buttons={buttons} />
            <LoadingSpinner show={this.state.loading} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="CustomerBuilder">
          <div className="panel panel-form">
            <Tabs tabs={this.tabs()} />
            <div className="tab-content">
              {/* <CustomerBuilderGeneralTab {...this.props} {...this.state} onChange={this.onChange} onChangeFormFields={this.onChangeFormFields} onChangeSelectedRating={this.onChangeSelectedRating} onChangeSelectedEmoji={this.onChangeSelectedEmoji} onChangeFormFieldFileUploadGroup={this.onChangeFormFieldFileUploadGroup} /> */}
              <CustomerBuilderGeneralTab {...this.props} {...this.state} onChange={this.onChange} onChangeFormFields={this.onChangeFormFields} onChangeSelectedRating={this.onChangeSelectedRating} onChangeSelectedEmoji={this.onChangeSelectedEmoji} onChangeAddress={this.onChangeAddress} handlePlaceSelect={this.handlePlaceSelect} />
              <CustomerBuilderCardsTab {...this.props} {...this.state} onChangeCardForm={this.onChangeCardForm} />
              <CustomerBuilderPaymentsTab {...this.props} {...this.state} />
              <CustomerBuilderReservationsTab {...this.props} {...this.state} />
              <CustomerBuilderEmailsTab {...this.props} {...this.state} />
              {this.props.enable_messaging ? <MessageLog {...this.props} {...this.state} /> : null}
              <CustomerBuilderVouchersTab {...this.props} {...this.state} />
              <CustomerBuilderNotesTab {...this.props} {...this.state} buttons={buttons} updateNoteCount={this.updateNoteCount} onChangeFileUploadGroup={this.onChangeFileUploadGroup} onChangeNote={this.onChangeNote} onChangeFlagged={this.onChangeFlagged}  />
            </div>
            <ModalButtons loading={this.state.loading} buttons={buttons} />
            <LoadingSpinner show={this.state.loading} />
          </div>
        </div>
      );
    }
  }

  tabs(){
    if (this.props.new_record === true) {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: this.state.errors && this.state.errors.header_errors? this.state.errors.header_errors.length : null,
        },
        // {
        //   tabName: I18n.t('cards'),
        //   targetName: 'cards',
        //   classes: this.state.active_tab === 'cards' ? 'active' : null,
        //   changeHandler: this.onChangeActiveTab,
        //   tabErrorCount: this.state.errors && this.state.errors.cards_header_errors? this.state.errors.cards_header_errors.length : null,
        // },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.active_tab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        }
      ]
    );
    } else {
      return (
        [
          {
            tabName: I18n.t('general'),
            targetName: 'general',
            classes: this.state.active_tab === 'general' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: this.state.errors && this.state.errors.general_tab_header_errors ? this.state.errors.general_tab_header_errors.length : null,
          },
          {
            tabName: I18n.t('cards'),
            targetName: 'cards',
            classes: this.state.active_tab === 'cards' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
            tabErrorCount: this.state.errors && this.state.errors.cards_header_errors ? this.state.errors.cards_header_errors.length : null,
          },
          {
            tabName: I18n.t('payments'),
            targetName: 'payments',
            classes: this.state.active_tab === 'payments' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('reservations'),
            targetName: 'reservations',
            classes: this.state.active_tab === 'reservations' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('emails'),
            targetName: 'emails',
            classes: this.state.active_tab === 'emails' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          ... this.props.enable_messaging ? [{
            tabName: I18n.t('text_messages'),
            targetName: 'message_logs',
            classes: this.state.active_tab === 'message_logs' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          }] : [],
          {
            tabName: I18n.t('vouchers'),
            targetName: 'vouchers',
            classes: this.state.active_tab === 'vouchers' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          },
          {
            tabName: I18n.t('notes'),
            targetName: 'notes',
            classes: this.state.active_tab === 'notes' ? 'active' : null,
            changeHandler: this.onChangeActiveTab,
          }
        ]
      );
    }
  };

  updateNoteCount(count) {
    this.setState({
      note_count: count,
    })
  }

  onChangeFormFieldFileUploadGroup(file_upload_group, form_field_id) {
    var self = this
    if (file_upload_group) {
      self.setState({
        customer_file_upload_group: file_upload_group,
        customer_image_form_field_id: form_field_id,
      })
    }
  }

  onChangeFileUploadGroup(file_group) {
    this.setState({file_group: file_group});
  }

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj);
      note_obj.note = noteText;

      this.setState({
        note_obj: note_obj
      });
    };
  };

  onChangeFlagged(e) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = e.target.checked
    this.setState({note_obj: note_obj});
  }

  onChangeCardForm(e) {
    var card  = this.state.customer.card ? Object.assign({}, this.state.customer.card) : {}
    var customer = Object.assign({}, this.state.customer)
    card[e.target.name] = e.target.value
    customer.card = card
    this.setState({ customer: customer });
  };

  onChange(e) {
    var customer = this.state.customer;
    var nameRegEx = /customer\[(.*)\]/;
    customer[nameRegEx.exec(e.target.name)[1]] = e.target.value;
    this.setState({customer: customer});
  }

  onChangeActiveTab(active_tab) {
    this.setState({active_tab, active_tab});
  }

  onChangeFormFields(e) {
    var answers = this.state.answers
    this.props.forms.map(group => {
      group.map((field) => {
        if(field.id === e.target.id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === e.target.id) {
                found = true;
                break;
              }
            }
          }
          if (found) {
            answers.map((answer) => {
              if (answer.form_field_id === e.target.id) {
                if (e.target.name == "number") {
                  answer.number_answer = e.target.value;
                } else if (e.target.name == "date") {
                  answer.date_answer = e.target.value; 
                } else {
                  answer.answer = e.target.value;
                }
              }
            });
          } else {
            if (!answers) {
              answers = [];
            }
            if (e.target.name == "number") {
              var new_answer = {
                form_field_id: e.target.id,
                number_answer: e.target.value,
              };
            } else if (e.target.name == "date") {
              var new_answer = {
                form_field_id: e.target.id,
                date_answer: e.target.value,
              };
            } else {
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value
              }
            }

            answers.push(new_answer)
          }
        }
      })
    })
    this.setState({answers: answers})
  }

  onChangeSelectedEmoji(emoji, form_field) {
    var answers = this.state.emoji_answers
      this.props.forms.map(group => {
        group.map((field) => {
          if(field.id === form_field.id) {
            var found = false;
            if(answers) {
              for(var i = 0, ilen = answers.length; i < ilen; i++) {
                if (answers[i].form_field_id === form_field.id) {
                  found = true;
                  break;
                }
              }
            }
            if (found) {
              answers.map((answer) => {
                if (answer.form_field_id === form_field.id) {          
                  answer.answer = emoji + ""
                  answer.form_field_id = form_field.id
                  answer.form_field_type = form_field.field_type
                  answer.selected = !answer.selected
                  
                } 
              })
            } else {
              if(!answers) {
                answers = []
              }
              var new_answer = {
                answer: emoji + "",
                form_field_id: form_field.id,
                form_field_type: form_field.field_type,
                selected: true
              }
              answers.push(new_answer)
            }
          }
        })
      })
      this.setState({emoji_answers: answers})
    }

    onChangeSelectedRating(rating, form_field){
      var answers = this.state.rating_answers

      this.props.forms.map(group => {
      group.map((field) => {
        if(field.id === form_field.id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === form_field.id) {
                found = true;
                break;
              }
            }
          }
          if (found) {
            answers.map((answer) => {
              if (answer.form_field_id === form_field.id) {       
                answer.answer = rating + ""
                answer.form_field_id = form_field.id
                answer.form_field_type = form_field.field_type
                answer.selected = !answer.selected      
              } 
            })
          } else {
            if(!answers) {
              answers = []
            }
            var new_answer = {
              answer: rating + "",
              form_field_id: form_field.id,
              form_field_type: form_field.field_type,
              selected: true
            }
            answers.push(new_answer)
          }
        }
      })
    })

    this.setState({rating_answers: answers})
  }

  handlePlaceSelect(answers) {
    this.setState({
      answers: answers,
    })
  }

  onChangeAddress(form_field_id, e) {
    var answers = this.state.answers;
    this.props.forms.map((group) => {
      group.map((field) => {
       if(field.id === form_field_id) {
         var found = false;
         if(answers) {
           for(var i = 0, ilen = answers.length; i < ilen; i++) {
             if (answers[i].form_field_id === form_field_id) {
               found = true;
               break;
             }
           }
         }
         if (found) {
           answers.map(answer => {
             if (answer.form_field_id === form_field_id) {
               answer.formatted_address = e.target.value        
             }
           })
         } else {
           if(!answers) {
             answers = []
           }
           if(e.target.name == 'answers[formatted_address]') {
             var new_answer = {
               form_field_id: form_field_id,
               formatted_address: e.target.value
             }
           }
           answers.push(new_answer)
         }
       }
     })
    })
    this.setState({
      answers: answers,
      form_field_address_field_id: form_field_id,
    })
  }

  save() {
    var self = this;
    this.setState({loading: true});

    if (self.laddaSubmitButton) {
      self.laddaSubmitButton.start();
    }

    if (this.state.note_obj.note) {
      var note_obj = this.state.note_obj
    }

    $.ajax({
      type: 'POST',
      url: this.props.form_action,
      data: {
        customer: this.state.customer,
        customer_answers: this.state.answers ? JSON.stringify(this.state.answers) : null,
        file_group_files: this.state.file_group && this.state.file_group.file_uploads ? this.state.file_group.file_uploads.map(file => file.id) : null,
        note: note_obj || null,
        customer_form_flag: true,
        rating_answers: self.state.rating_answers.length > 0 ? JSON.stringify(self.state.rating_answers) : null,
        emoji_answers: self.state.emoji_answers.length > 0 ? JSON.stringify(self.state.emoji_answers) : null,


      },
    }).done((data) => {
      if (self.laddaSubmitButton) {
        self.laddaSubmitButton.stop();
      }
      if (data && data.errors) {
        self.setState({errors: data.errors, success: null, loading: false});
      } else {
        self.setState({errors: null, success: I18n.t('customer_saved_successfully'), loading: false}, () => {
          if (self.props.onSuccess) {
            self.props.onSuccess();
          }

          if(parent && parent.refresh_data) {
            //console.log("R", this.props)
            if (this.props.new_record == true) {
              parent.refresh_data(I18n.t('customer_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('customer_saved_successfully'));
            }
          }


          window.parent.$(window.parent).trigger("customerSuccessfully")

          window.handleAlertSuccess();
          
          if(parent && parent.hide_modal) {
            parent.hide_modal();
          }
        });
      }
    });
  };

};

export default CustomerBuilder
